var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.6C0 8.6877 2.69175 11.2 6 11.2H6.75V14L10.5 10.5L6.75 7V9.8H6C3.51825 9.8 1.5 7.9163 1.5 5.6C1.5 3.2837 3.51825 1.4 6 1.4C8.48175 1.4 10.5 3.2837 10.5 5.6V6.3H12V5.6C12 2.5123 9.30825 0 6 0C2.69175 0 0 2.5123 0 5.6Z",
    fill: "#6165DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.4a7e48d586fa06d8d9a0a36bcc58de2e.svg";
export { ForwardRef as ReactComponent };